module.exports = "<div ng-form=\"form\"\n  class=\"row\">\n  <my-input class=\"col s12 m8\"\n    ng-model=\"myArea.name\"\n    my-options=\"fieldsOptions.name\"\n    enable-validator=\"enableValidator\">\n  </my-input>\n\n  <my-switch class=\"col s12 m4\"\n    my-label=\"fieldsOptions.isReal.label\"\n    ng-model=\"myArea.isReal\"\n    enable-validator=\"enableValidator\">\n  </my-switch>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/entities/rails/area/directives/forms/myAreaForm.html
// module id = 913
// module chunks = 0